"use strict";
// Copyright (C) 2017-2025 Smart code 203358507
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importStar(require("react"));
var classnames_1 = __importDefault(require("classnames"));
var Checkbox_less_1 = __importDefault(require("./Checkbox.less"));
var Button_1 = __importDefault(require("../Button"));
var react_2 = __importDefault(require("@stremio/stremio-icons/react"));
var Checkbox = react_1.default.forwardRef(function (_a, ref) {
    var _b, _c, _d;
    var name = _a.name, disabled = _a.disabled, className = _a.className, label = _a.label, href = _a.href, link = _a.link, onChange = _a.onChange, error = _a.error, checked = _a.checked;
    var handleSelect = (0, react_1.useCallback)(function (event) {
        if (!disabled && onChange) {
            onChange({
                type: 'select',
                checked: event.target.checked,
                reactEvent: event,
                nativeEvent: event.nativeEvent,
            });
        }
    }, [disabled, onChange]);
    var onKeyDown = (0, react_1.useCallback)(function (event) {
        if ((event.key === 'Enter' || event.key === ' ') && !disabled) {
            onChange && onChange({
                type: 'select',
                checked: !checked,
                reactEvent: event,
                nativeEvent: event.nativeEvent,
            });
        }
    }, [disabled, checked, onChange]);
    return (react_1.default.createElement("div", { className: (0, classnames_1.default)(Checkbox_less_1.default['checkbox'], className) },
        react_1.default.createElement("label", { className: Checkbox_less_1.default['label'], htmlFor: name },
            react_1.default.createElement("div", { className: (0, classnames_1.default)(Checkbox_less_1.default['checkbox-container'], (_b = {}, _b[Checkbox_less_1.default['checked']] = checked, _b), (_c = {}, _c[Checkbox_less_1.default['disabled']] = disabled, _c), (_d = {}, _d[Checkbox_less_1.default['error']] = error, _d)), role: 'checkbox', tabIndex: disabled ? -1 : 0, "aria-checked": checked, onKeyDown: onKeyDown },
                react_1.default.createElement("input", { ref: ref, id: name, type: 'checkbox', checked: checked, disabled: disabled, onChange: handleSelect, className: Checkbox_less_1.default['input'] }),
                checked ?
                    react_1.default.createElement(react_2.default, { name: 'checkmark', className: Checkbox_less_1.default['checkbox-icon'] })
                    : null),
            react_1.default.createElement("div", null,
                react_1.default.createElement("span", null, label),
                ' ',
                href && link ?
                    react_1.default.createElement(Button_1.default, { className: Checkbox_less_1.default['link'], href: href, target: '_blank', tabIndex: -1 }, link)
                    : null))));
});
exports.default = Checkbox;
